import { Languages } from './enum/languages.enum';

/**
 * Базовый язык player-контента (описания, guide texts, facts).
 * Модераторы русские → сначала RU, остальные языки локализуются от него.
 * Канонические entity-поля (slug, title/name, tags) остаются на латинице/EN.
 */
export const CONTENT_BASE_LANGUAGE = Languages.RU;
